// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__FFOHO","footer":"ReportModalFilter_footer__1ZLx1"};